// project import
import dashboard from './dashboard';
import pages from './page';
import movimientos from './movimientos';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, movimientos]
};

export default menuItems;
